import { render, staticRenderFns } from "./remindDetailList.vue?vue&type=template&id=5377f63a&scoped=true"
import script from "./remindDetailList.vue?vue&type=script&lang=js"
export * from "./remindDetailList.vue?vue&type=script&lang=js"
import style0 from "./remindDetailList.vue?vue&type=style&index=0&id=5377f63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377f63a",
  null
  
)

export default component.exports